'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { useStore } from 'zustand';

import { DifferentCityConfirmationModal } from './different-city-confirmation-modal.component';

import {
  acceptDifferentCityConfirmation,
  cancelDifferentCityConfirmation,
  differentCityConfirmationStore,
  dropDifferentCityConfirmation,
} from '@/store/cart/different-city-confirmation.store';

export function DifferentCityConfirmationHost() {
  const isOpen = useStore(differentCityConfirmationStore, (state) => state.isOpen);

  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    if (prevPathnameRef.current === pathname) {
      return;
    }

    prevPathnameRef.current = pathname;
    dropDifferentCityConfirmation();
  }, [pathname]);

  return (
    <DifferentCityConfirmationModal
      open={isOpen}
      onAccept={acceptDifferentCityConfirmation}
      onCancel={cancelDifferentCityConfirmation}
    />
  );
}
